export const CAMPAIGN_DEFAULT_DURATION = 5; // длительность кампании по дефолту 5 дней
export const CAMPAIGN_DEFAULT_QUOTA_NAME = 'qcountry';
export const DEFAULT_QUOTA_COUNT = 100;
export const DEFAULT_COUNTRY = 'Россия';
